import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="App-footer">
      © 2024 BMERIT
    </footer>
  );
};

export default Footer;
